import {createContext, useContext} from 'react';

/**
 * Provider value for CL-011 Calendly consultation links (Contentful Link + rich text).
 * - App root (`CalendlyTriggerProvider`): validates using the resolved document-level Calendly segment.
 * - Showroom detail: a nested provider wraps the “Book a consultation” block with store-specific availability.
 *
 * @typedef {Object} CalendlyConsultationLinksValue
 * @property {true} active
 * @property {boolean} inPersonBookingAvailable
 * @property {boolean} videoBookingAvailable
 * @property {boolean} [showFindShowroomFallback] - KINDW-1296: non–showroom-detail only; replace in-person CTA
 * @property {string} [findShowroomHref] - Localized storefront path to showroom list
 */

/** @type {import('react').Context<CalendlyConsultationLinksValue | null>} */
export const CalendlyConsultationLinksContext = createContext(null);

/**
 * @returns {CalendlyConsultationLinksValue | null}
 */
export function useCalendlyConsultationLinks() {
  return useContext(CalendlyConsultationLinksContext);
}
